var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpvoteBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 10a6.626 6.626 0 1113.252 0 6.626 6.626 0 01-13.252 0zm6.626-7.875a7.876 7.876 0 100 15.752 7.876 7.876 0 000-15.752zm.442 4.534a.625.625 0 00-.884 0L7.384 8.834a.625.625 0 10.883.884l1.109-1.109v4.292a.625.625 0 101.25 0V8.61l1.108 1.109a.625.625 0 00.884-.884l-2.175-2.175z"
  })));
}
export default SvgUpvoteBig;